import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function RawDataRegisterToggle({ register, setRegister }) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mb: "20px" }}>
            <ToggleButtonGroup
                value={register}
                exclusive
                onChange={(e, val) => val && setRegister(val)}
                aria-label="Register Toggle"
                sx={{
                    backgroundColor: "#161B22",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: "10px",
                    "& .MuiToggleButton-root": {
                        color: "rgba(255,255,255,0.5)",
                        border: "none",
                        fontSize: "0.85rem",
                        fontWeight: 500,
                        textTransform: "none",
                        px: "24px",
                        py: "8px",
                        borderRadius: "10px",
                        "&.Mui-selected": {
                            color: "#FDB940",
                            backgroundColor: "rgba(253,185,64,0.08)",
                            fontWeight: 700,
                            "&:hover": { backgroundColor: "rgba(253,185,64,0.12)" },
                        },
                        "&:hover": { backgroundColor: "rgba(255,255,255,0.04)" },
                    },
                }}
            >
                <ToggleButton value="ActivePower">Active Power</ToggleButton>
                <ToggleButton value="TotalActiveEnergy">Total Active Energy</ToggleButton>
                <ToggleButton value="SignalQuality">Signal Quality</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
